import events from "./events/phase4_events";
import tickets from "./supportTickets/phase4_supportTickets";

export default {
  modules: {
    events,
    tickets,
  },
};
